export const formatTimeAgo = (dateString: string, t: any) => {
  // Если сервер отдает локальное время с 'Z', нужно добавить offset
  const utcDate = new Date(dateString);
  if (Number.isNaN(utcDate.getTime())) {
    return '';
  }
  const date = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
  const now = new Date();
  const diffInHours = Math.max(0, Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60)));
  const diffInDays = Math.floor(diffInHours / 24);
  
  if (diffInDays > 0) {
    // Manually format for proper Russian/English display
    const template = t('proposals.timeAgo.daysHours');
    return template.replace('{{days}}', diffInDays.toString()).replace('{{hours}}', (diffInHours % 24).toString());
  } else {
    const template = t('proposals.timeAgo.hours');
    return template.replace('{{hours}}', diffInHours.toString());
  }
};
